import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import ReportStore from '../../stores/ReportStore';

const DEFAULT_ROW = 26
class PrintReportKKCPurchaseOrderSummary extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false, affiliates:[],data:[],dataList:[],report_title:'กำลังดึงข้อมูล..'}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this.loadData()
  }

  loadData() {
    ReportStore.loadReportPurchaseOrderByShop(this.props.year,this.props.month,this.props.credit,(result)=>{
      this.setState({data:result.data,affiliates:result.affiliates,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
    })
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getCredit() {
    let credit = (this.props.credit==='45'?' (เครดิต 45 วัน)':this.props.credit==='60'?' (เครดิต 60 วัน)': ' (รวม)')
    return credit
  }

  getSummary(key) {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      let value = item[key]
      if (value===''||value===null||value===undefined||isNaN(value))
        value = 0

      sum += parseFloat(value)
    })

    return sum  
  }

  getAllSummary() {
    let {affiliates} = this.state
    let that = this
    let sum = 0
    affiliates.forEach(function(item,index) {
      sum += parseFloat(that.getSummary(item.affiliates_id))
    })              
    return sum
  }

  renderAffiliates(ditem){
    let {affiliates} = this.state
    return affiliates.map((item,index)=>{
      if(ditem[item.affiliates_id]!==undefined){
        return (<td key={index} className='text-right'>{this.getNumberFormat(ditem[item.affiliates_id])}</td>)
      }else{
        return (<td  key={index} className='text-right'>-</td>)
      }
    })
  }

  renderRowData(items,indexs) {
    if (items.length===0) {
      return(
        <tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>
      )
    } else {
      return(
        items.map((item,index) => {
          return(
            <tr key={index}>
              <td>{item.shop_name}</td>
              <td className='text-right'>{this.getNumberFormat(item.stock)}</td>
              <td className='text-right'>{this.getNumberFormat(item.customer)}</td>
              {this.renderAffiliates(item)}
              <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
            </tr>
          )
        })
      )    
    }      
  }
  
  renderTable(items,indexs,length) {
    let {affiliates} = this.state
    let {year,month} = this.props
    return(
      <div>
        <table className='table table-hover table-bordered-solid table-report-kkc-purchase-order-summary table-print-report-kkc-purchase-order-summary'>
          <thead>
            <tr>
              <th colSpan={14+affiliates.length} className='text-center bg-1'><h2 style={{marginTop:'5px',marginBottom:'0'}}>{this.props.title+this.getCredit()} {month==='0'?'ปี ':'เดือน '+(month==='1'?'มกราคม':month==='2'?'กุมภาพันธ์':month==='3'?'มีนาคม':month==='4'?'เมษายน':month==='5'?'พฤษภาคม':month==='6'?'มิถุนายน':month==='7'?'กรกฎาคม':month==='8'?'สิงหาคม':month==='9'?'กันยายน':month==='10'?'ตุลาคม':month==='11'?'พฤศจิกายน':'ธันวาคม')} {year}</h2></th>
            </tr>
            <tr>
              <th rowSpan={2} className='text-center bg-2' style={{verticalAlign:'top'}}>สถานที่ซื้อ</th>
              <th className='text-center bg-2'></th>
              <th colSpan={1 + affiliates.length } className='text-center bg-2'>เจ้าของรถ</th>
              <th className='text-center bg-2'>จำนวนเงิน</th>
            </tr>
            <tr>
              <th className='text-center bg-2 color-blue'>สต็อกอู่</th>
              <th className='text-center bg-2 color-blue'>อู่-ลูกค้า</th>
              {
                affiliates.map((item,index)=>(
                  <th key={index} className='text-center bg-2 color-blue'>{item.name}</th>
                ))
              }
              <th className='text-center bg-2 color-blue'></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className='text-center color-blue bg-3'><u>เงินสดเชื่อ</u></td>
              <td className='text-center'></td>
              <td className='text-center'></td>
              {
                affiliates.map((item,index)=>(
                  <td key={index} className='text-center'></td>
                ))
              }
              <td className='text-center'></td>
            </tr>
            {this.renderRowData(items,indexs)}
          </tbody>
          <tfoot>
            <tr>
              <th className='bg-2 text-center color-blue'><u>รวมเงินเชื่อ</u></th>
              <th className='bg-2 text-right'>{indexs===length?this.getNumberFormat(this.getSummary('stock')):'-'}</th>
              <th className='bg-2 text-right'>{indexs===length?this.getNumberFormat(this.getSummary('customer')):'-'}</th>
              {
                affiliates.map((item,index)=>(                  
                  <th key={index} className='bg-2 text-right'>{indexs===length?this.getNumberFormat(this.getSummary(item.affiliates_id)):'-'}</th>
                ))
              }
              <th className='bg-2 text-right'>{indexs===length?this.getNumberFormat(this.getSummary('amount')):'-'}</th>
            </tr>
            <tr>
              <th className='bg-2 text-center'>ส่วนของลูกค้า</th>
              <th className='bg-2 text-right'>{indexs===length?this.getNumberFormat(this.getSummary('stock')+this.getSummary('customer')):'-'}</th>
            </tr>
            <tr>
              <th className='bg-2 text-center'>ส่วนของในเครื่อ</th>
              <th className='bg-2 text-right'>{indexs===length?this.getNumberFormat(this.getAllSummary()):'-'}</th>
            </tr>
          </tfoot>
        </table>
        {this.renderFooter()}
      </div>
    )
  }  

  renderFooter() {
    return(
          <div className='footer-page'>
            <div>
              <table className='table table-print-car-summary-doc-2'>
                <tbody>
                  <tr>
                    <td className='text-center'>
                      <div>(........................................)</div>
                      <div>เจ้าหน้าที่จัดซื้อ</div>
                      <div>(สุวรรณภา ทาสันเทียะ)</div>
                      <div>จัดทำ</div>
                    </td>
                    <td className='text-center'>
                      <div>(........................................)</div>
                      <div>เจ้าหน้าที่บัญชี</div>
                      <div>(สุภาวดี ปราบวงษา)</div>
                    </td>
                    <td className='text-center'>
                      <div>(........................................)</div>
                      <div>รองผู้จัดการ</div>
                      <div>(ไกรวิชญ์ พงษ์เกาะ)</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <table className='table table-print-car-summary-doc-2'>
                <tbody>
                  <tr>
                    <td className='text-center'>
                      <div>(........................................)</div>
                      <div>ผู้จัดการ</div>
                      <div>(สมเดช เรดสันเทียะ)</div>
                      <div>รับทราบ</div>
                    </td>
                    <td className='text-center'>
                      <div>(........................................)</div>
                      <div>กรรมการผู้จัดการ</div>
                      <div>(เกษม พงษ์เกาะ)</div>
                      <div>รับทราบ</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
    )
  }

  renderComponentPage(items,indexs,length) {
    return(
      <div className='font-print'>
        {this.renderTable(items,indexs,length)}
      </div>  
    )
  }

  getPagination(data) {
    let newData = []
    let allData = []
    let checkRow = 0

    data.forEach(function(item,index) {
      if (checkRow<DEFAULT_ROW) {
        checkRow++
        newData.push(item)
      }  

      if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
        allData.push(newData)
        checkRow = 0
        newData = []
      }
    })  
    
    return allData
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render() {
    let {loading,dataList} = this.state
    if (dataList.length===0) {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title+this.getCredit()}
        >
          {this.renderNoData()}
        </PrintPreview>
      )  
    } else {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title+this.getCredit()}>
          {
            dataList.map((item,index) => {
              return this.renderComponentPage(item,index,dataList.length-1)
            })  
          }
        </PrintPreview>
      )
    }  
  }

}  

PrintReportKKCPurchaseOrderSummary.defaultProps = {
  title: 'สรุปยอดการสั่งซื้อวัสดุ - อะไหล่ - สี ',  
  mode : '1'
}
export default PrintReportKKCPurchaseOrderSummary;


// WEBPACK FOOTER //
// ./src/view/print/PrintReportKKCPurchaseOrderSummary.js